module.exports = __webpack_public_path__ + "img/infoguidance_mov_06.d0801600.jpg";